import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {IDeleteReviewPhotoPayload, IReviewPhotoPayload, IReviewPhotoResponse} from "../interfaces/IFile";
import { renameFile } from "../../utils/transliterateFilename";

const BASE_API = process.env.REACT_APP_BASE_API;
const KRANKQUE_SECRET_KEY = process.env.REACT_APP_KRANKQUE_SECRET_KEY;
const KRANKQUE_APPLICATION_ID = process.env.REACT_APP_KRANKQUE_APPLICATION_ID;


export const fileSlice = createApi({
  reducerPath: 'file',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState }) => {
      if (KRANKQUE_SECRET_KEY) {
        headers.set('krankque-secret-key', KRANKQUE_SECRET_KEY);
      }

      if (KRANKQUE_APPLICATION_ID) {
        headers.set('krankque-application-id', KRANKQUE_APPLICATION_ID);
      }

      return headers;
    },
  }),
  endpoints: (builder) => ({
    uploadAvatar: builder.mutation<any, File>({
      query: (file) => {
        const formData = new FormData();
        const renamedFile = renameFile(file);

        formData.append('file', renamedFile);

        return {
          url: '/avatar',
          method: 'POST',
          body: formData,
        };
      },
    }),

    uploadReviewImage: builder.mutation<IReviewPhotoResponse, IReviewPhotoPayload>({
      query: ({reviewId, file}) => {
        const formData = new FormData();
        const renamedFile = renameFile(file);

        formData.append('file', renamedFile);
        formData.append('reviewId', reviewId)

        return {
          url: '/review-photo',
          method: 'POST',
          body: formData,
        }
      },
    }),

    deleteReviewImage: builder.mutation<IReviewPhotoResponse, IDeleteReviewPhotoPayload>({
      query: ({reviewId, fileKey}) => {
        return {
          url: '/review-photo',
          method: 'DELETE',
          params: {
            reviewId,
            fileKey,
          },
        }
      },
    }),
  }),
});

export const { useUploadAvatarMutation, useUploadReviewImageMutation, useDeleteReviewImageMutation } = fileSlice;
